import React, { useEffect, useMemo, useState } from 'react';
import ContainerHeader from '../components/ContainerHeader';
import { ColumnDirective, ColumnsDirective, ContextMenu, Filter, GridComponent, Group } from '@syncfusion/ej2-react-grids';
import { Inject, Page, Sort, Search, Toolbar } from '@syncfusion/ej2-react-grids';
import { Button } from '@material-ui/core';
import useTimberSalesPricingListController from './CustomHooks/useTimberSalesPriceListController';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

import ConfirmationDialog from '../components/ConfirmDialogs/ConfirmationDialog';
import useHandleDialog from './CustomHooks/useHandleDialog';
import useDefaultSiteVersion from './CustomHooks/useDefaultSiteVersion';
import { Dialog, DialogTitle, DialogContent, DialogActions, MenuItem, Select, CircularProgress } from '@mui/material';
import useConvertToContract from './CustomHooks/useConvertToContract';
import ConvertToContractModal from './components/ConvertToContractModal';
import { useRef } from 'react';
import { useToast } from 'context/tostifyContext';
import { useAllUsers } from 'context/AllUserDataContext';
import { useSelector } from 'react-redux';

class DebugBoundary extends React.Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught error:', error, info);
  }
  render() {
    if (this.state.hasError) return <div>Error in grid rendering</div>;
    return this.props.children;
  }
}
// const contextMenuItems = [{ text: 'Convert to Contract', target: '.e-content', id: 'convertToContract' }];

const TimberSalesPricingList = props => {
  const [addendumDialogOpen, setAddendumDialogOpen] = useState(false);
  const [addendumRowData, setAddendumRowData] = useState(null);

  const pageSettings = useMemo(
    () => ({
      pageSize: 30,
      pageSizes: [5, 10, 20, 30, 40],
    }),
    [],
  );
  const filterSettings = {
    type: 'Excel',
  };
  const history = useHistory();
  const {
    salesPricingData,
    handleConvertToContract,
    createClone,
    deleteTimberList,
    getSalesPricingList,
  } = useTimberSalesPricingListController();

  const {
    open,
    confirmOpen,
    openVersionDialog,
    closeVersionDialog,
    setConfirmOpen,
    siteAssessmentList,
    selectedSiteId,
    setSelectedSiteId,
    checkAndCreate,
    confirmDeleteAndCreate,
    loading,
    handleAddAsAddendum,
  } = useDefaultSiteVersion(getSalesPricingList);

  const { authUser } = useSelector(({ auth }) => auth);

  const { openConvertToContract, setOpenConvertToContract } = useConvertToContract();

  const { dialogState, openDialog, closeDialog } = useHandleDialog();

  const contractRowDataRef = useRef(null);

  const { showToast } = useToast();

  const toolbarOptions = [
    { text: 'Search', tooltipText: 'Search', prefixIcon: 'e-search', id: 'search' },
    // { text: 'Add Woodchip Sample', id: 'addNewWoodChipSample', tooltipText: 'Add a new Woodchip Sample' },
    // { template: customToolbar },
  ];

  let grid;

  useEffect(() => {
    grid.refresh();
  }, [salesPricingData]);

  function EditPricngVersion(rowData) {
    return (
      <Button
        key={`${rowData.pricingVersion}_pricing`}
        style={{ color: 'blue', fontWeight: 'bold', width: '100%' }}
        onClick={() => {
          history.push(`/timberSalesPricing/${rowData.siteAssessmentID}/${rowData.pricingVersion}`);
        }}>
        {rowData.pricingVersion}
      </Button>
    );
  }
  const handleActionBegin = args => {
    if (args.requestType === 'beginEdit' || args.requestType === 'save') {
      setTimeout(() => {
        // safe state updates here
      }, 0);
    }
  };

  const contractTemplate = props => {
    return Number(props.contractDoneFlag) === 1 ? (
      <span style={{ color: 'green', fontWeight: 600 }}>✅ Yes</span>
    ) : (
      <span style={{ color: 'gray' }}>No</span>
    );
  };

  const handleAddendumConfirm = () => {
    if (addendumRowData) {
      handleAddAsAddendum(addendumRowData.pricingVersion, addendumRowData.spNumber);
      setAddendumDialogOpen(false);
      setAddendumRowData(null);
    }
  };

  const canAccess = useMemo(
    () =>
      authUser?.email === 'eoin@worrellharvesting.ie' ||
      authUser?.email === 'kenneth@worrellharvesting.ie',
    [authUser?.email]
  );

  const contextMenuOpen = args => {
    try {
      const rowData = args?.rowInfo?.rowData;
      if (!rowData || !grid?.contextMenuModule?.contextMenu) return;

      const menu = grid.contextMenuModule.contextMenu;
      const hasContract = !!rowData.spNumber;
      const isCloned = rowData.pricingVersion && !rowData.pricingVersion.toString().endsWith('-0');

      // Find the contract row for this site (if any)
      const contractRow = salesPricingData.find(row => row.siteAssessmentID === rowData.siteAssessmentID && !!row.spNumber);

      // Extract version number suffix e.g. "ABC-2" => 2
      const getVersionNumber = version => {
        const parts = version?.toString().split('-');
        return parts ? parseInt(parts[parts.length - 1]) : 0;
      };

      const currentVersionNum = getVersionNumber(rowData.pricingVersion);
      const contractVersionNum = contractRow ? getVersionNumber(contractRow.pricingVersion) : -1;

      // Is this row older than the contract version?
      const isOlderThanContract = contractRow && !hasContract && currentVersionNum < contractVersionNum;

      // Reset — show all first
      menu.showItems(['Convert to Contract', 'Clone', 'Delete', 'Add as Addendum']);

      if (hasContract) {
        // This row IS the contract: only Clone
        menu.hideItems(['Convert to Contract', 'Delete', 'Add as Addendum']);
      } else if (isOlderThanContract) {
        // Superseded by a newer contract: only Delete
        menu.hideItems(['Convert to Contract', 'Clone', 'Add as Addendum']);
      } else if (isCloned) {
        // Newer than contract or no contract, cloned version: Addendum, Clone, Delete
        menu.hideItems(['Convert to Contract']);
      } else {
        // Original (xxx-0), no contract anywhere: Convert, Clone, Delete
        menu.hideItems(['Add as Addendum']);
      }
    } catch (err) {
      console.error('Error in contextMenuOpen:', err);
    }
  };

  const handleDialogConfirm = async () => {
    try {
      closeDialog();

      if (dialogState.type === 'clone') {
        await createClone(dialogState.rowData);
      } else if (dialogState.type === 'delete') {
        await deleteTimberList(dialogState.rowData);
      }

      getSalesPricingList();
    } catch (err) {
      console.error('❌ Error in handleDialogConfirm:', err);
    }
  };

  const contextMenuClick = args => {
    const rowData = args.rowInfo?.rowData;

    // if (rowData.spNumber) {
    //   args.cancel = true;
    // }

    if (args.item.id === 'convertToContract') {
      if (rowData.spNumber) {
        showToast('❌ Not allowed to create contract, Contract already created');
        return;
      }
      contractRowDataRef.current = rowData;
      setOpenConvertToContract(true);
    }

    if (args.item.id === 'clone') {
      openDialog('clone', rowData);
    }

    if (args.item.id === 'addendum') {
      setAddendumRowData(rowData);
      setAddendumDialogOpen(true);
    }

    if (args.item.id === 'delete') {
      if (rowData.spNumber) {
        showToast('❌ Not allowed to delete contract');
        return;
      }
      openDialog('delete', rowData);
    }
  };

  const contextMenuItems = [
    { text: 'Convert to Contract', target: '.e-rowcell', id: 'convertToContract' },
    { text: 'Clone', target: '.e-rowcell', id: 'clone' },
    { text: 'Delete', target: '.e-rowcell', id: 'delete' },
    { text: 'Add as Addendum', target: '.e-rowcell', id: 'addendum' },
  ];

  const customToolbar = () => {
    return (
      <Button variant="contained" size="small" onClick={openVersionDialog} style={{ margin: '0 10px' }}>
        Create Default Version
      </Button>
    );
  };

  function SiteAssesmentTemplate(props) {
    const history = useHistory();

    const handleClick = () => {
      history.push(`/siteAssessment`);
    };

    return (
      <span style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} onClick={handleClick}>
        {props.siteAssessmentID}
      </span>
    );
  }

  function SpNumberTemplate(props) {
    const history = useHistory();

    const handleClick = () => {
      history.push(`/siteContracts/${props.spNumber}`);
    };

    return (
      <span style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} onClick={handleClick}>
        {props.spNumber}
      </span>
    );
  }

  return (
    <>
      {dialogState.open && (
        <ConfirmationDialog
          open={true}
          confirmationText={`Do you want to ${dialogState.type} this item?`}
          confirmationFun={handleDialogConfirm}
          declineFunction={closeDialog}
          setOpen={() => closeDialog()}
        />
      )}

      {openConvertToContract && (
        <ConvertToContractModal
          open={openConvertToContract}
          onClose={() => setOpenConvertToContract(false)}
          contractRowData={contractRowDataRef}
        />
      )}

      {/* Addendum Confirmation Dialog */}
      <Dialog
        open={addendumDialogOpen}
        onClose={() => {
          setAddendumDialogOpen(false);
          setAddendumRowData(null);
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            minWidth: '400px',
            minHeight: '200px',
          },
        }}>
        <DialogTitle>Add as Addendum</DialogTitle>
        <DialogContent style={{ paddingTop: '20px' }}>
          Are you sure you want to add pricing version <strong>"{addendumRowData?.pricingVersion}"</strong> as an addendum?
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px' }}>
          <Button
            onClick={() => {
              setAddendumDialogOpen(false);
              setAddendumRowData(null);
            }}>
            Cancel
          </Button>
          <Button onClick={handleAddendumConfirm} variant="contained" color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <div className="app-wrapper siteWrapper">
        <ContainerHeader match={props.match} title={'Timber Sales List'} />
        <div style={{ height: 'calc(100vh - 145px)', width: '100%', paddingTop: '0.5rem' }}>
          <DebugBoundary>
            <Button variant="contained" style={{ marginBottom: '10px' }} onClick={openVersionDialog}>
              Create Default Version
            </Button>

            {/* Site ID Dialog */}
            <Dialog
              open={open}
              onClose={closeVersionDialog}
              maxWidth="sm"
              fullWidth
              PaperProps={{
                style: {
                  minWidth: '400px',
                  minHeight: '250px',
                },
              }}>
              <DialogTitle>Select Site Assessment ID</DialogTitle>
              <DialogContent style={{ paddingTop: '20px' }}>
                <Select
                  fullWidth
                  value={selectedSiteId}
                  onChange={e => {
                    setSelectedSiteId(e.target.value); // This sets only the ID
                  }}
                  displayEmpty>
                  <MenuItem value="" disabled>
                    Select an ID
                  </MenuItem>
                  {siteAssessmentList.map(fullString => {
                    const id = fullString.split(':')[0].trim(); // Extract ID for value
                    return (
                      <MenuItem key={fullString} value={id}>
                        {' '}
                        {fullString} {/* display shows full formatted string */}
                      </MenuItem>
                    );
                  })}
                </Select>
              </DialogContent>
              <DialogActions style={{ padding: '16px 24px' }}>
                <Button onClick={closeVersionDialog}>Cancel</Button>
                <Button onClick={checkAndCreate} variant="contained" disabled={!selectedSiteId || loading}>
                  {loading ? <CircularProgress size={20} /> : 'Create'}
                </Button>
              </DialogActions>
            </Dialog>

            {/* Confirmation Dialog */}
            <Dialog
              open={confirmOpen}
              onClose={() => setConfirmOpen(false)}
              maxWidth="sm"
              fullWidth
              PaperProps={{
                style: {
                  minWidth: '450px',
                  minHeight: '200px',
                },
              }}>
              <DialogTitle>Default Version Exists</DialogTitle>
              <DialogContent style={{ paddingTop: '20px' }}>
                Default version already exists for ID <strong>{selectedSiteId}</strong>.<br />
                Do you want to delete it and create a new one?
              </DialogContent>
              <DialogActions style={{ padding: '16px 24px' }}>
                <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
                <Button onClick={confirmDeleteAndCreate} variant="contained" color="primary">
                  Yes, Create New
                </Button>
              </DialogActions>
            </Dialog>
            <GridComponent
              ref={g => (grid = g)}
              dataSource={salesPricingData}
              contextMenuItems={contextMenuItems}
              contextMenuClick={contextMenuClick}
              contextMenuOpen={contextMenuOpen}
              filterSettings={filterSettings}
              allowPaging={true}
              pageSettings={pageSettings}
              allowSorting={true}
              allowTextWrap={true}
              allowResizing={true}
              allowMultiSorting={true}
              allowReordering={true}
              allowFiltering={true}
              style={{
                minHeight: 'auto !important',
              }}
              actionBegin={handleActionBegin}
              height="100%"
              toolbar={toolbarOptions}>
              <ColumnsDirective>
                <ColumnDirective
                  field="pricingVersion"
                  headerText="Pricing Version"
                  width="80"
                  textAlign="Left"
                  template={EditPricngVersion}
                  isPrimaryKey={true}
                />
                <ColumnDirective field="timberPricingLabel" headerText="Label" width="80" />
                <ColumnDirective
                  field="siteAssessmentID"
                  headerText="Site Assessment ID"
                  width="80"
                  clipMode="EllipsisWithTooltip"
                  template={SiteAssesmentTemplate}
                />
                <ColumnDirective field="spNumber" headerText="SP Number" width="80" template={SpNumberTemplate} />
                <ColumnDirective field="wH_NumberName" headerText="SP Details" width="80"  />
                <ColumnDirective
                  field="contractDoneFlag"
                  headerText="Contract Created"
                  width="120"
                  template={contractTemplate}
                />
                <ColumnDirective field="totalCosts" headerText="Total Cost" width="80" />
                <ColumnDirective field="totalHectares" headerText="Total Hectares" width="80" />
                <ColumnDirective field="totalTonnes" headerText="Total Tonnes" width="80" />
              </ColumnsDirective>
              <Inject
                services={
                  canAccess
                    ? [Page, Sort, Filter, Group, Search, Toolbar, ContextMenu]
                    : [Page, Sort, Filter, Group, Search, Toolbar]
                }
              />            </GridComponent>
          </DebugBoundary>
        </div>
      </div>
    </>
  );
};

export default TimberSalesPricingList;
